import { useCallback, useEffect, useState } from "react";
import prop from "ramda/src/prop";
import uniqBy from "ramda/src/uniqBy";
import compose from "ramda/src/compose";

import useAuth from "../../routes/login/AuthContext";
import { EntrataUser, LoadEntrataUsers } from "../../services/IntegrationApi";

export const useEntrataUsers = () => {
  const { getAuthToken } = useAuth();
  const [loading, setLoading] = useState<boolean>(true);
  const [users, setUsers] = useState<EntrataUser[]>([]);

  const loadUsers = useCallback(async (page = 0) => {
    const results = await LoadEntrataUsers(page, await getAuthToken());

    const handleNewUsers = compose(uniqBy(prop("id")), (users: EntrataUser[]) =>
      users.concat(results.content)
    );

    setUsers(handleNewUsers as any);
    setLoading(false);
  }, []);

  useEffect(() => {
    loadUsers(0);
  }, []);

  return {
    users,
    loading,
    loadUsers,
  };
};
